var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56487 0.794861C6.62516 -0.264954 8.34343 -0.264954 9.40371 0.794861C10.4635 1.85515 10.4635 3.57342 9.40371 4.6337C4.10373 9.93368 4.10373 18.5265 9.40371 23.8267C14.7037 29.1267 23.2965 29.1267 28.5967 23.8267C33.8967 18.5267 33.8967 9.93393 28.5967 4.6337C27.5369 3.57342 27.5369 1.85515 28.5967 0.794861C29.657 -0.264954 31.3753 -0.264954 32.4356 0.794861C39.8556 8.21493 39.8556 20.246 32.4356 27.6656C25.0155 35.0851 12.9845 35.0856 5.56487 27.6656C-1.85471 20.2455 -1.8552 8.21445 5.56487 0.794861ZM17.3559 20.3296L11.0197 14.1075C8.46981 11.5486 12.2948 7.71023 14.8443 10.2691L14.8698 10.2947C15.6546 11.0922 16.2951 10.8295 16.2951 9.70346V4.72483C16.2951 3.22722 17.5135 2.01498 19.0158 2.01498H18.9841C20.4908 2.01498 21.7044 3.22819 21.7044 4.72483V9.70346C21.7044 10.8276 22.3429 11.0942 23.1306 10.2947L23.1562 10.2691C25.7056 7.71023 29.5306 11.5486 26.9807 14.1075L20.7312 20.3201C19.8025 21.2432 18.2911 21.2479 17.3559 20.3296L17.3559 20.3296Z",
    fill: "#FFD600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAssessment);
export default __webpack_public_path__ + "static/media/saveAssessment.2d2a60f7364d396e22f5dfefcc9bf2fa.svg";
export { ForwardRef as ReactComponent };